module.exports = __webpack_public_path__ + "2c6a3e961eb8f628f65ec40f4a505298.svg";